import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue";
const _hoisted_1 = {
    "data-cy": "delivery-charge-list",
    class: "list-wrapper"
};
const _hoisted_2 = { class: "table-control mb-2" };
const _hoisted_3 = { class: "d-flex align-center" };
const _hoisted_4 = { class: "table-only" };
const _hoisted_5 = { class: "td__area-config" };
const _hoisted_6 = { key: 0 };
import { deliveryChargeTableHeader } from '@/constants/storeManagement/deliveryChargeDialog';
import { computed, onMounted, ref, withModifiers, } from 'vue';
import { initAutoLc } from '@/locales/ko/views/delivery_charge_dialog';
import { deliveryChargeGetterType } from '@/vuex-store/delivery-charge-dialog/getters';
import { deliveryChargeActionType } from '@/vuex-store/delivery-charge-dialog/actions';
import vuexStore from '@/vuex-store';
import { alertActionType } from '@/vuex-store/alert/actions';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { i18n } from '@/locales';
import TotalCount from '@/components/TotalCount.vue';
import BrgPagination from '@/components/BrgPagination.vue';
import { autoLcCommon } from '@/locales/ko/common';
import SearchInput from '@/components/Form/SearchInput.vue';
import ChargeItem from './ChargeItem.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliveryChargeList',
    setup(__props) {
        const lc = initAutoLc('list_area.');
        const lcDialogDelete = initAutoLc('dialog_delete.');
        const tableHeader = deliveryChargeTableHeader;
        const lcCommon = autoLcCommon();
        const noDataText = ref('');
        /**
         * row 수정 상태 여부
         */
        const isEditRow = (value) => value;
        // 배달 대행료 리스트
        const searchWord = computed(() => vuexStore.state.deliveryChargeDialog.filterOption.searchWord.value);
        const updateNoDateText = () => {
            const path = searchWord.value
                ? 'no_search_data_text'
                : 'no_data_text';
            noDataText.value = lcCommon(path);
        };
        // 배달 대행료 리스트
        const itemList = computed(() => vuexStore.getters[deliveryChargeGetterType.getterDeliveryChargeList]);
        // 배달 대행료 리스트
        const paginationData = computed(() => vuexStore.getters[deliveryChargeGetterType.getterPaginationData]);
        // 페이지 관련
        const computedPageNumber = computed({
            get() {
                return paginationData.value.pageNumber;
            },
            async set(pageNumber) {
                await vuexStore.dispatch(deliveryChargeActionType.setPageNumber, pageNumber);
                await vuexStore.dispatch(deliveryChargeActionType.getDeliveryChargeList);
                updateNoDateText();
            },
        });
        const getterCheckedList = computed(() => vuexStore.getters[deliveryChargeGetterType.getterCheckedList]);
        /**
         * 선택항목삭제 확인창
         */
        const confirm = () => vuexStore.dispatch(alertActionType.confirm, {
            headerTitle: lcDialogDelete('title'),
            bodyContent: i18n.t('common.confirm_before_delete_for_selected_item'),
            btnConfig: [
                {
                    text: 'cancel',
                    cssClass: 'outlined info',
                },
                {
                    text: 'ok',
                    cssClass: 'danger',
                },
            ],
        });
        /**
         * 배달대행료 추가 버튼 클릭 핸들러
         */
        const handleClickAddItem = async () => {
            vuexStore.dispatch(deliveryChargeActionType.setToggleForm, true);
            vuexStore.dispatch(deliveryChargeActionType.cancelEdit);
        };
        /**
         * 배달대행료 삭제 핸들러
         */
        const handleClickDeleteItem = async () => {
            const isConfirm = await confirm();
            if (!isConfirm) {
                return;
            }
            try {
                await vuexStore.dispatch(deliveryChargeActionType.deleteCheckedItem);
                vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t('common.success'));
                await vuexStore.dispatch(deliveryChargeActionType.getDeliveryChargeList);
                updateNoDateText();
            }
            catch (error) {
                if (error instanceof Error) {
                    vuexStore.dispatch(snackbarActionType.showError, error.message || 'common.unknown_error');
                }
            }
        };
        /**
         * 채크리스트 업데이트 핸들러
         * @param checkedList
         */
        const handleUpdateModelValue = (checkedList) => {
            vuexStore.dispatch(deliveryChargeActionType.setCheckedList, checkedList);
        };
        /**
         * 배달대행료 검색 핸들러
         */
        const handleSearch = async (value) => {
            await vuexStore.dispatch(deliveryChargeActionType.setFilterOption, {
                searchWord: {
                    field: 'specialArea',
                    value,
                },
            });
            await vuexStore.dispatch(deliveryChargeActionType.onSearch);
            updateNoDateText();
        };
        onMounted(async () => {
            await vuexStore.dispatch(deliveryChargeActionType.getDeliveryChargeList);
            updateNoDateText();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            const _component_v_data_table_server = _resolveComponent("v-data-table-server");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" <div\n        class=\"contents-title-text\"\n      >\n        {{ lc('title') }}\n        (\n        <template\n          v-if=\"getterCheckedList.length > 0\"\n        >\n          {{ getterCheckedList.length }}\n          /\n        </template>\n        {{ paginationData.total }}\n        )\n      </div> "),
                    _createVNode(TotalCount, null, {
                        default: _withCtx(() => [
                            _cache[1] || (_cache[1] = _createTextVNode(" 총 ")),
                            (getterCheckedList.value.length > 0)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(getterCheckedList.value.length) + " / ", 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(" " + _toDisplayString(paginationData.value.total) + " 건 ", 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */,
                        __: [1]
                    }),
                    _createElementVNode("div", _hoisted_3, [
                        _createCommentVNode(" 선택 삭제 "),
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            disabled: getterCheckedList.value.length === 0,
                            onClick: handleClickDeleteItem
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createTextVNode(" mdi-trash-can-outline ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [2]
                                }),
                                _createTextVNode(" " + _toDisplayString(_unref(lc)('selected_item_delete')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["disabled"])), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    danger: true,
                                    "size-l": true
                                }
                            ]
                        ]),
                        _createCommentVNode(" 배달 대행료 추가 "),
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            class: "ml-4",
                            onClick: handleClickAddItem
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                        _createTextVNode(" mdi-plus ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [3]
                                }),
                                _createTextVNode(" " + _toDisplayString(_unref(lc)('add')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    primary: true,
                                    "size-l": true
                                }
                            ]
                        ]),
                        _createCommentVNode(" 검색 "),
                        _createVNode(SearchInput, {
                            class: "ml-4",
                            width: 300,
                            outlined: "",
                            "on-search": handleSearch,
                            "default-value": "",
                            placeholder: _unref(lc)('search_placeholder')
                        }, null, 8 /* PROPS */, ["placeholder"])
                    ])
                ]),
                _createCommentVNode(" 테이블 "),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_data_table_server, {
                        hover: "",
                        "hide-default-footer": "",
                        "fixed-header": "",
                        "show-select": "",
                        "item-value": "id",
                        density: "comfortable",
                        class: "registered-area-list-table brg-table brg-checkbox-table",
                        headers: _unref(tableHeader),
                        items: itemList.value,
                        "items-per-page": -1,
                        "items-length": -1,
                        "model-value": getterCheckedList.value,
                        "no-data-text": noDataText.value,
                        "onUpdate:modelValue": handleUpdateModelValue
                    }, {
                        [`header.data-table-select`]: _withCtx(({ someSelected, allSelected, selectAll }) => [
                            _createVNode(_component_v_checkbox, {
                                "model-value": allSelected,
                                indeterminate: someSelected && !allSelected,
                                density: "compact",
                                "hide-details": "",
                                "onUpdate:modelValue": (value) => selectAll(value)
                            }, null, 8 /* PROPS */, ["model-value", "indeterminate", "onUpdate:modelValue"])
                        ]),
                        [`item.data-table-select`]: _withCtx(({ isSelected, toggleSelect, internalItem }) => [
                            _createVNode(_component_v_checkbox, {
                                "model-value": isSelected([internalItem]),
                                density: "compact",
                                "hide-details": "",
                                onclick: withModifiers(() => toggleSelect(internalItem), ['stop'])
                            }, null, 8 /* PROPS */, ["model-value", "onclick"])
                        ]),
                        [`item.areaConfig`]: _withCtx(({ item }) => [
                            _createElementVNode("td", _hoisted_5, [
                                _createTextVNode(_toDisplayString(item) + " ", 1 /* TEXT */),
                                _createCommentVNode(" 수정일 경우 "),
                                (isEditRow(item))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                        _createVNode(_component_v_btn, {
                                            icon: "mdi-check",
                                            density: "compact",
                                            color: "blue",
                                            variant: "text",
                                            class: "mr-1",
                                            onClick: () => { }
                                        }),
                                        _createVNode(_component_v_btn, {
                                            icon: "mdi-close",
                                            density: "compact",
                                            color: "black",
                                            variant: "text",
                                            onClick: () => { }
                                        })
                                    ]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createCommentVNode(" 기본 상태 "),
                                        _createElementVNode("div", null, [
                                            _createVNode(_component_v_btn, {
                                                icon: "mdi-pencil-outline",
                                                density: "compact",
                                                color: "black",
                                                variant: "text",
                                                class: "mr-1",
                                                onClick: () => { }
                                            }),
                                            _createVNode(_component_v_btn, {
                                                icon: "mdi-trash-can-outline",
                                                density: "compact",
                                                color: "black",
                                                variant: "text",
                                                onClick: () => { }
                                            })
                                        ])
                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                            ])
                        ]),
                        item: _withCtx(({ isSelected, internalItem, toggleSelect, item }) => [
                            _createVNode(ChargeItem, _normalizeProps(_guardReactiveProps({ isSelected, internalItem, toggleSelect, item: item })), null, 16 /* FULL_PROPS */)
                        ]),
                        bottom: _withCtx(() => _cache[4] || (_cache[4] = [])),
                        _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["headers", "items", "model-value", "no-data-text"])
                ]),
                _createVNode(BrgPagination, {
                    modelValue: computedPageNumber.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((computedPageNumber).value = $event)),
                    length: paginationData.value.pages
                }, null, 8 /* PROPS */, ["modelValue", "length"])
            ]));
        };
    }
});
